var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { FormoAnalytics } from "./FormoAnalytics";
import { initStorageManager, logger } from "./lib";
var defaultContext = {
    chain: function () { return Promise.resolve(); },
    page: function () { return Promise.resolve(); },
    reset: function () { return Promise.resolve(); },
    detect: function () { return Promise.resolve(); },
    connect: function () { return Promise.resolve(); },
    disconnect: function () { return Promise.resolve(); },
    signature: function () { return Promise.resolve(); },
    transaction: function () { return Promise.resolve(); },
    identify: function () { return Promise.resolve(); },
    track: function () { return Promise.resolve(); },
};
export var FormoAnalyticsContext = createContext(defaultContext);
export var FormoAnalyticsProvider = function (props) {
    var writeKey = props.writeKey, _a = props.disabled, disabled = _a === void 0 ? false : _a, children = props.children;
    // Keep the app running without analytics if no Write Key is provided or disabled
    if (!writeKey) {
        console.error("FormoAnalyticsProvider: No Write Key provided");
        return children;
    }
    if (disabled) {
        console.warn("FormoAnalytics is disabled");
        return children;
    }
    return _jsx(InitializedAnalytics, __assign({}, props));
};
var InitializedAnalytics = function (_a) {
    var writeKey = _a.writeKey, options = _a.options, children = _a.children;
    var _b = useState(defaultContext), sdk = _b[0], setSdk = _b[1];
    var initializedStartedRef = useRef(false);
    initStorageManager(writeKey);
    var initializeFormoAnalytics = function (writeKey, options) { return __awaiter(void 0, void 0, void 0, function () {
        var sdkInstance, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, FormoAnalytics.init(writeKey, options)];
                case 1:
                    sdkInstance = _a.sent();
                    setSdk(sdkInstance);
                    console.log("FormoAnalytics SDK initialized successfully");
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Failed to initialize FormoAnalytics SDK", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var initialize = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (initializedStartedRef.current)
                            return [2 /*return*/];
                        initializedStartedRef.current = true;
                        return [4 /*yield*/, initializeFormoAnalytics(writeKey, options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        initialize();
    }, [writeKey, options]);
    return (_jsx(FormoAnalyticsContext.Provider, { value: sdk, children: children }));
};
export var useFormo = function () {
    var context = useContext(FormoAnalyticsContext);
    if (!context) {
        logger.warn("useFormo called without a valid context");
    }
    return context; // Return undefined if SDK is not initialized, handle accordingly in consumer
};
//# sourceMappingURL=FormoAnalyticsProvider.js.map